import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import styles from "./DefaultFooter.module.css";

function DefaultFooter({ content }) {
  const { brand, socials, menus, copyright } = content;

  return (
    <MKBox component="footer">
      <Container maxWidth="xl">
        <Grid container spacing={4} py={4} alignItems="flex-start">
          {/* Brand + socials */}
          <Grid item xs={12} md={3} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Link to={brand.route} className={styles.brandImageWrap}>
              <MKBox component="img" src={brand.image} alt={brand.name} maxWidth="7rem" />
            </Link>
            <MKTypography variant="h6" display="block" mb={2}>
              {brand.name}
            </MKTypography>
            <MKBox
              display="flex"
              alignItems="center"
              gap={2}
              flexWrap="wrap"
              justifyContent={{ xs: "center", md: "flex-start" }}
            >
              {socials.map(({ icon, link }) => (
                <a
                  key={link}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.socialLink}
                >
                  {icon}
                </a>
              ))}
            </MKBox>
          </Grid>

          {/* Menu columns */}
          {menus.map(({ name: title, items }, menuIdx) => (
            <Grid key={title} item xs={6} md>
              <span className={styles.menuTitle}>{title}</span>
              <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                {items.map(({ name, route, href }) => (
                  <MKBox key={name} component="li" mb={0.75}>
                    {href ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.menuLink}
                        style={
                          menuIdx === menus.length - 1 ? { wordBreak: "break-word" } : undefined
                        }
                      >
                        {name}
                      </a>
                    ) : (
                      <Link to={route} className={styles.menuLink}>
                        {name}
                      </Link>
                    )}
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
        </Grid>

        <div className={styles.copyright}>{copyright}</div>
      </Container>
    </MKBox>
  );
}

DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
